import moment from 'moment'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import './styles.scss'

const InfoHeaderPayment = ({ date: orderDate, amount, currency = 'eur' }) => {

  const [date, time] = moment(orderDate).format('DD/MM/YYYY HH:mm').split(' ')

  return (
    <div className='container-header-info'>
      <div className='container-date-and-hour'>
        <label className='title-date-and-our'>{I18n.t('plugins_refund_payment_dateAndHour').toUpperCase()}</label>
        <div className='date-and-hour-label'>
          <label>{orderDate? date: ''}</label>
          <label className='label-time'>{orderDate? time: ''}</label>
        </div>
      </div>
      <div className='container-date-and-hour'>
        <label className='title-date-and-our'>{I18n.t('plugins_refund_payment_cant').toUpperCase()}</label>
        <div className='date-and-hour-label'>
          <label className='label-time'>{amount}</label>
          <i className={`fa fa-${currency.toLowerCase()} label-time`} style={{ marginLeft: '1px', fontSize:'13px' }}></i>
        </div>
      </div>
    </div>
  )

}

export default InfoHeaderPayment